module.exports = __webpack_public_path__ + "img/photo-icon.3033ad7.svg";